export default "__VITE_ASSET__BTAZtMEr__"